<template>
  <v-container fluid class="py-0">
    <v-row dense class="text-caption" align="center">
      <v-col>
        {{
          $moment(note.updatedAt, "YYYY-MM-DD HH:mm:ss ZZ")
            | moment("DD/MM/Y HH:mm")
        }}
      </v-col>

      <v-col cols="auto">
        <v-dialog v-model="showForm" width="700">
          <template v-slot:activator="{ on: dialog, attrs }">
            <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  x-small
                  icon
                  :attrs="attrs"
                  v-on="{ ...tooltip, ...dialog }"
                >
                  <v-icon>eva-edit-outline</v-icon>
                </v-btn>
              </template>

              <span>
                Editar
              </span>
            </v-tooltip>
          </template>

          <v-card>
            <v-card-title>
              <v-row dense>
                <v-col> Editar nota - {{ categoryName }} </v-col>

                <v-col cols="auto">
                  <!-- <authorization
                    permissionKey="attendance_note"
                    can="delete"
                    v-slot:default="{ authorization }"
                  > -->
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        @click="deleteNote"
                      >
                        <!-- v-if="authorization" -->
                        <v-icon color="error">eva-trash-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Excluir
                    </span>
                  </v-tooltip>
                  <!-- </authorization> -->
                </v-col>
              </v-row>
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="note.message"
                    v-uppercase
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="showForm = false">
                cancelar
              </v-btn>

              <v-btn color="primary" text @click="saveNote">
                salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-row dense class="text-body-4">
      <v-col class="text">
        {{ note.message }} 
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AttendanceNote",
  props: {
    attendanceId: String,
    categoryName: String,
    note: Object,
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    saveNote() {
      this.$store.dispatch("updateLoading", true);

      this.apolloMutate({
        mutation: require("@/graphql/note/save_note.gql"),
        variables: {
          attendanceId: this.attendanceId,
          noteCategoryId: this.note.category.id,
          noteId: this.note.id,
          message: this.note.message,
        },
      }).then(() => {
        this.showForm = false;
      });
    },
    deleteNote() {
      if (confirm("Você realmente deseja deletar essa nota?")) {
        this.apolloMutate({
          mutation: require("@/graphql/note/delete_note.gql"),
          variables: {
            noteId: this.note.id,
          },
        }).then(() => {
          this.showForm = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hover {
  cursor: pointer;
}

.text {
  white-space: pre-line;
}
</style>
